// extracted by mini-css-extract-plugin
module.exports = {"enter":"loading-styles_enter__2gnN6","enterActive":"loading-styles_enterActive__1XXP-","exit":"loading-styles_exit__1LfZA","exitActive":"loading-styles_exitActive__3omMd"};